export const APP_NAME = 'Megan RealEstate'
